import { SubscriptionFormulaDTO } from "@chatsystem/common/dtos";
import React, { Dispatch } from "react";

export type SubscriptionContextValue = {
  subscriptionData: {
    subscriptionsFormulas: SubscriptionFormulaDTO[];
    selectedFormulaId: number;
    justSubscribedSuccessfully: boolean;
  };
};

type StripePricesContext = {
  subscriptionData: {
    subscriptionsFormulas: SubscriptionFormulaDTO[];
    selectedFormulaId: number;
    justSubscribedSuccessfully: boolean;
  };
  setSubscriptionData: Dispatch<SubscriptionContextValue>;
};

export default React.createContext<StripePricesContext>({
  subscriptionData: {
    subscriptionsFormulas: [],
    selectedFormulaId: null,
    justSubscribedSuccessfully: false,
  },
  setSubscriptionData: (value) => {},
});
